import React, { useState } from 'react';
import TreeNode from './TreeNode.esm.js';

var TreeBranch = function (props) {
    var dataMetrics = props.dataMetrics, dataTestId = props.dataTestId, item = props.item, level = props.level;
    var _a = useState(false), selected = _a[0], setSelected = _a[1];
    var hasChildren = item.children && item.children.length !== 0;
    var renderBranches = function () {
        var newLevel = level + 1;
        return item.children.map(function (child) { return (React.createElement(TreeBranch, { key: child.id, item: child, level: newLevel })); });
    };
    var toggleSelected = function () {
        setSelected(!selected);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(TreeNode, { dataMetrics: dataMetrics, dataTestId: dataTestId, item: item, selected: selected, hasChildren: hasChildren, level: level, onToggle: toggleSelected }),
        selected && hasChildren && renderBranches()));
};

export { TreeBranch as default };
//# sourceMappingURL=TreeBranch.esm.js.map
